module.exports = __webpack_public_path__ + "img/uninstall.ed7be4eb.svg";